/**
 * The date picker, now @vuepic/vue-datepicker - a vue 3 component, where vuejs-datepicker
 * was the last vue 2 library in the app and the last thing `INSTANCE_LISTENERS` was held
 * open for. See ./README.md.
 *
 * It emits `update:model-value` and declares it in `emits`, so nothing falls through to the
 * root element and the flag goes off with the package. The v-model it speaks is the vue 3
 * pair, which is what the app speaks now that COMPONENT_V_MODEL is off.
 *
 * The package exports no default in v14, only the named `VueDatePicker`, and its stylesheet
 * is shipped separately - imported here so the package has one import site and the css
 * lands in whichever chunk actually uses the picker.
 *
 * The app does not reach for this directly: vue/common_components/DateInput.vue is what the
 * call sites mount, and it carries the settings they all shared.
 */
import '@vuepic/vue-datepicker/dist/main.css';
import { VueDatePicker } from '@vuepic/vue-datepicker';

export default VueDatePicker;
